// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1__tf","cls2":"UserTaggingPingBodyStyles-cls2_k1v UserTaggingPingBodyStyles-cls1__tf"};